<template>
  <v-layout my-3>
    <v-flex>
      <v-btn
        style="height: 70px"
        class="nuevoArrendatario"
        block
        outline
        :disabled="disabled"
        color="primary"
        @click="$emit('addArrendatario')"
      >
        <slot name="icon">
        <v-icon color="primary" 
          :disabled="disabled"
          :class="$vuetify.breakpoint.lgAndUp ? 'btnAddArrendatario' : ''"
          class="custom-icon" 
          large>
          {{icon}}
        </v-icon>
        </slot>
        <span :class="[[disabled ? '' : 'primary--text'], [$vuetify.breakpoint.lgAndUp ? 'textoAddArrendatario' : '']]"><slot></slot></span>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'add-arrendatario',
  props: {
    value: {
      type: Boolean
    },
    icon: {
      type: String,
      default: 'icon-new-user'
    },
    disabled: {
      type: Boolean
    }
  }
}
</script>

<style lang="stylus" scoped>

  .textoAddArrendatario
    position: absolute
    left: 55px;
    top: 50%;
    transform: translateY(-50%);
    

  .btnAddArrendatario
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);

  .nuevoArrendatario
    border-style: dashed

</style>



// WEBPACK FOOTER //
// src/components/generic/AddArrendatario.vue